import { Link } from "react-router-dom";
import { ArrowDown, MapPin } from "@phosphor-icons/react";
import { SOCIETY } from "@/lib/data";

export const Hero = () => {
  return (
    <section
      data-testid="home-hero"
      className="relative min-h-[100svh] w-full overflow-hidden bg-brand-forest text-brand-ivory"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1714386450133-fc18de6fe2d2?auto=format&fit=crop&w=2000&q=85"
          alt="iTowers Exente at golden hour"
          className="w-full h-full object-cover animate-subtle-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-forest/65 via-brand-forest/45 to-brand-forest/95" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-40 md:pt-48 pb-16 min-h-[100svh] flex flex-col justify-between">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.32em] font-semibold text-brand-gold mb-8 animate-fade-up">
            <span className="w-10 h-px bg-brand-gold" />
            The Official Community Portal
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-[clamp(3rem,9vw,8rem)] leading-[0.95] tracking-tight animate-fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            Welcome to
            <br />
            <span className="italic text-brand-gold">{SOCIETY.name}.</span>
          </h1>

          <p
            className="mt-8 max-w-xl text-lg md:text-xl text-brand-ivory/85 leading-relaxed animate-fade-up"
            style={{ animationDelay: "0.25s" }}
          >
            {SOCIETY.tagline} — a Kolte-Patil community of 438 homes set
            across four lush acres in the heart of Electronic City.
          </p>

          <div
            className="mt-12 flex flex-wrap items-center gap-4 animate-fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            <Link
              to="/about"
              data-testid="hero-cta-explore"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-brand-ivory text-brand-forest text-sm font-semibold hover:bg-brand-gold transition-colors"
            >
              Discover the community
            </Link>
            <Link
              to="/visitors"
              data-testid="hero-cta-visitors"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-brand-ivory/40 text-brand-ivory text-sm font-medium hover:bg-brand-ivory/10 transition-colors"
            >
              Visiting? Get a pass
            </Link>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-6 max-w-3xl">
          {SOCIETY.stats.map((s, i) => (
            <div
              key={s.label}
              data-testid={`hero-stat-${i}`}
              className="border-t border-brand-ivory/25 pt-4 animate-fade-up"
              style={{ animationDelay: `${0.55 + i * 0.08}s` }}
            >
              <div className="font-display text-4xl md:text-5xl text-brand-gold">
                {s.value}
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-brand-ivory/70 mt-1">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        <div className="absolute bottom-6 right-6 md:right-10 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-brand-ivory/70">
          <a
            href={SOCIETY.mapsUrl}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 hover:text-brand-gold transition-colors"
            data-testid="hero-map-link"
          >
            <MapPin size={14} weight="light" /> Electronic City, Bengaluru
          </a>
        </div>

        <div className="absolute bottom-6 left-6 md:left-10 flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-brand-ivory/70">
          <ArrowDown size={14} weight="light" className="animate-bounce" /> Scroll
        </div>
      </div>
    </section>
  );
};
